import { render, staticRenderFns } from "./file-example.vue?vue&type=template&id=5d80daf9&scoped=true&"
import script from "./file-example.vue?vue&type=script&lang=js&"
export * from "./file-example.vue?vue&type=script&lang=js&"
import style0 from "./file-example.vue?vue&type=style&index=0&id=5d80daf9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d80daf9",
  null
  
)

export default component.exports